/**
 @ngdoc service
 @name excelService

 @description
 Create Excel files on the fly from JSON data
 Currently only supports CSVs
 Code based upon https://jsfiddle.net/1ecj1rtz/ from https://stackoverflow.com/questions/28892885/javascript-json-to-excel-file-download
 I suspect we could also generate XSLS too (see https://jsfiddle.net/shaswatatripathy/fo4ugmLp/1/)
 Useful formatting CSV tips: http://www.creativyst.com/Doc/Articles/CSV/CSV01.htm

 @usage

 excelService.newCSV()
 .newRow()
 .addCell()
 .addRow()
 .download()

 @example
 var mockDataList = [ ['cell A1','cell B1','cell C1'], ['cell A2','cell B2','cell C2'], ['cell ","A3','cell \n B3','cell\' C3'] ];
 var csv = excelService.newCSV( 'my new excel file' );
 var csvRow;
 for( var idxRow in mockDataList){
            csvRow = csv.newRow();
            for( var idxColumn in mockDataList[idxRow]){
                csv.addCell( csvRow, mockDataList[idxRow][idxColumn] );
            }
            csv.addRow(csvRow);
        }
 csv.download();
 return;

 */
var excelService = function($filter, logService) {
    //set up for debugging file
    var logObj = logService.init('excelService',false);

    this.setDebug = function(debug){
        logObj.debug = debug;
    };

    /**
     * Creates a new CSV object
     * @param fileName (string)                 - Desired file name of the csv. Will be parsed to remove sapces/unsafe characters
     * @param addTimeStamp (boolean)(optional)  - adds a timestamp to the file name
     * @param separator (string)(optional)      - Allows you to specify the separator type
     * @returns {{fileName: *, addTimeStamp: *, separator: *, csvData: string, uri: string, newRow: newRow, addCell: addCell, addRow: addRow, download: download}}
     */
    this.newCSV = function(fileName, addTimeStamp, separator){
        var csv = {
            fileName:       formatFileName(fileName, addTimeStamp, separator),
            csvData:        CONFIG.CSV.START_LINE + CONFIG.CSV.NEW_ROW,
            uri:            CONFIG.CSV.URI,
            newRow: function(){
                return {value:'',length:0};
            },
            addCell: function(row,cellValue){
                //console.log(cellValue);
                if(cellValue && typeof cellValue=="string")
                {
                    row.value += '"' + cellValue.replace(/"/g, '""') + '"';
                }
                row.value += CONFIG.CSV.NEW_COLUMN;
                //console.log(row.value);
                row.length++;
            },
            addRow: function(row){
                this.csvData+=row.value.slice(0,-1)+CONFIG.CSV.NEW_ROW;
            },
            download: function(){
                this.fileName += CONFIG.CSV.EXTENSION;
                createDownloadLink(this.fileName,this.uri,this.csvData);
            }
        };
        return csv;
    };

    var createDownloadLink = function(filenameWithExtension, uri, data){
        //Generate a anchor element
        var link = document.createElement("a");
        //append the data to the file format and point the link to it
        link.href = uri + encodeURI(data);
        //set the visibility hidden so it will not effect on your web-layout
        link.style = "visibility:hidden";
        //set the file name
        link.download = filenameWithExtension;
        //Append to body
        document.body.appendChild(link);
        //click it
        link.click();
        //remove it
        document.body.removeChild(link);
    };

    var formatFileName = function(fileName, addTimeStamp, separator ){
        addTimeStamp    = handleDefault(addTimeStamp,true);
        separator       = handleDefault(separator,'_');
        var formattedFileName = fileName.replace(/ /g,separator) + (addTimeStamp ? separator + getTimestamp() : '');
        return formattedFileName;
    };

    var handleDefault = function(value, defaultValue){
        return value==undefined ? defaultValue : value;
    };

    /**
     *
     * @returns {string}
     */
    var getTimestamp = function(){
        var d = new Date();
        return d.toISOString().slice(0,-8).replace(/:/g,'');
    };

    var CONFIG = {
        /**
         * Comma Separated Values
         */
        CSV: {
            START_LINE:     'sep=,',
            URI:            'data:text/csv;charset=utf-8,',            //file format
            EXTENSION:      '.csv',
            NEW_ROW:        '\r\n',
            NEW_COLUMN:     ','
        },
        XLS: {

        }
    };
}
excelService.$inject = ['$filter', 'logService']
angular.module('app').service('excelService', excelService);